<template>
  <div class="row">
    <div class="col-md-6 border-end">
      <textarea
        class="form-control"
        placeholder="Log Description"
        v-model="logActivityData.description"
        rows="5"
      ></textarea>
      <div class="text-danger" v-if="errors.description">
        {{ errors.description[0] }}
      </div>
    </div>

    <div class="col-md-6 position-relative">
      <h6 class="mb-3">Log Type</h6>
      <div class="radio-group">
        <div
          v-for="(logType, index) in logTypes"
          :key="index"
          class="form-check"
        >
          <input
            type="radio"
            class="form-check-input"
            :id="'log-' + index"
            :value="logType"
            v-model="logActivityData.logType"
          />
          <label class="form-check-label" :for="'log-' + index">
            {{ logType }}
          </label>
        </div>
      </div>
      <!-- <div class="text-danger" v-if="errors.log_type">
                {{ errors.log_type[0] }}
            </div> -->
    </div>

    <!-- <div class="col-md-4 position-relative">
            <h6  class="mb-3">Templates</h6>
            <div class="template-buttons position-absolute top-0 end-0">
                <button
                class="btn btn-outline-primary btn-sm me-2"
                @click="toggleTemplateView('favorites')"
                :class="{ active: templateView === 'favorites' }"
                >
                Favorites
                </button>
                <button
                class="btn btn-outline-primary btn-sm"
                @click="toggleTemplateView('all')"
                :class="{ active: templateView === 'all' }"
                >
                All
                </button>
            </div>
            <p v-if="templateView === 'all' && templates.length === 0">
                No template available!
            </p>
        </div> -->

    <div class="col-md-12 mt-3">
      <div class="d-flex justify-content-end">
        <button class="btn btn-success" @click="saveLogActivity">
          <span v-if="!isLoading">Save Log Activity</span>
          <span v-else>Loading...</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  props: {
    leadId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,

      logTypes: [
        "Log a Call",
        "Log an E-mail",
        "Log a Meeting",
        "Visit Log",
        "WhatsApp",
      ],
      templateView: "all",
      templates: [],

      logActivityData: {
        description: "",
        logType: "",
      },

      currentPath:"",

      errors: {},
    };
  },
  mounted() {
    const fullPath = this.$route.fullPath;
    const lastPart = fullPath.split("/").filter(Boolean).pop();
    this.currentPath=lastPart;
  },
  methods: {
    toggleTemplateView(view) {
      this.templateView = view;
    },

    async saveLogActivity() {
      this.isLoading = true;
      const endpoint = "/store-leads-details-log-info";
      const method = "post";
      let body = {
        lead_id: this.leadId,
        description: this.logActivityData.description,
        log_type: this.logActivityData.logType,
        key_account: this.currentPath == 'key-account-details' ? 'Y':'N'
      };
      try {
        const response = await http[method](endpoint, body);
        this.$toast.success(response.data.message);
        this.$emitter.emit("form-submitted");
        this.errors = {};
        this.isLoading = false;
        this.logActivityData = {
          description: "",
          logType: "",
        };
      } catch (error) {
        this.isLoading = false;
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
